import { render, staticRenderFns } from "./widget-grid.vue?vue&type=template&id=0939ba4b&scoped=true&"
import script from "./widget-grid.vue?vue&type=script&lang=ts&"
export * from "./widget-grid.vue?vue&type=script&lang=ts&"
import style0 from "./widget-grid.vue?vue&type=style&index=0&id=0939ba4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0939ba4b",
  null
  
)

export default component.exports